import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButtonModule } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatDividerModule } from "@angular/material/divider";

@Component({
  selector: 'passengers-modal',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatSpinner,
    MatDividerModule
  ],
  templateUrl: './passengers-modal.component.html',
  styleUrl: './passengers-modal.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class PassagersModalComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PassagersModalComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService
  ) { }

  @Output() response = new EventEmitter<any>()

  form!: FormGroup;
  passengers: any[] = []; // Agora a lista vem da API
  loading = false;

  documentMask = '';
  cellphoneMask = '(00) 00000-0000';

  page = 1;
  rows = 10;
  numberRows = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ""
  editIndex: number | null = null;
  editAgendaItem: any = null;

  documentTypeList = [
    { id: 'cpf', descricao: 'CPF' },
    { id: 'rg', descricao: 'RG' },
    { id: 'cnh', descricao: 'CNH' }
  ];

  ngOnInit(): void {
    this.createForm();


  }

  checkDocAvailability(doc: string) {
    this.passangerService.searchPassengerByDocument(doc).subscribe({
      next: (res) => {
      },
      error: (err) => {
        console.error('Erro ao buscar passageiros', err);
      }
    })
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      nomePassageiro: ['', [Validators.required]],
      tipoDocumento: [''],
      numeroDoc: [''],
      contato: [''],
      horaChegada: [''],
      horaSaida: [''],
      voo: [''],
      companhia: ['']
    });
  }



  closeModal() {
    this.dialogRef.close();
  }



  addItemToList() {


    if (this.form.invalid) return



    const model = this.createModal()

    this.loading = true;
    this.resetForm()

    this.passangerService.createPassenger(model).subscribe({
      next: () => {

        this.dialogRef.close({ success: true });

      },
      error: (err) => {

        this.snackbar.error('Erro ao criar passageiro.');
        this.dialogRef.close({ success: false });
      },
      complete: () => {
        this.loading = false;

      }
    });

  }


  formatTime = (timeString: string) => {
    if (!timeString) return '';

    // Remove qualquer caractere não numérico
    const numericTime = timeString.replace(/\D/g, '');

    // Garante que temos pelo menos 4 dígitos (hhmm)
    const paddedTime = numericTime.padStart(4, '0');

    // Formata para hh:MM:ss
    return `${paddedTime.substr(0, 2)}:${paddedTime.substr(2, 2)}:00`;
  };

  createModal() {
    return {
      nome: this.form.get('nomePassageiro')?.value,
      documento: this.form.get('numeroDoc')?.value,
      contato: this.form.get('contato')?.value,
      voo: this.form.get('voo')?.value,
      companhia: this.form.get('companhia')?.value,
      horaPartida: this.formatTime(this.form.get('horaSaida')?.value),
      horaChegada: this.formatTime(this.form.get('horaChegada')?.value),
      ordemServicoId: this.data.idOs
    }
  }


  // Você pode implementar add/edit usando os métodos createPassenger/editPassenger da service

  onDocumentTypeChange(type: string) {
    if (type === 'cpf') {
      this.documentMask = '000.000.000-00';
    } else if (type === 'rg') {
      this.documentMask = '00.000.000-0';
    } else if (type === 'cnh') {
      this.documentMask = '00000000000';
    } else {
      this.documentMask = '';
    }
    this.form.get('numeroDoc')?.reset();
  }

  cancel() {
    this.editIndex = null;
    this.response.emit({ action: 'cancel' });
    this.resetForm();
  }

  resetForm() {
    this.form.reset();
  }
}
